export default __webpack_public_path__ + "static/media/publicBanner01.cc27486e.jpg";